import { render, staticRenderFns } from "./LuUser.vue?vue&type=template&id=70146cea&"
import script from "./LuUser.vue?vue&type=script&lang=js&"
export * from "./LuUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports